import React from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import Footer from '../../../../Components/FooterSection/Footer';
import { HashLink as Link } from 'react-router-hash-link';

import single from '../../../../images/single.webp'


const Create = () => {
    return (
        <div>
            <Box className='create'>
                <Container maxWidth='xl'>
                    <Grid container spacing={2} alignSelf={'center'}>
                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <Box padding={5}>
                                <Typography variant='h2'>
                                    NFT Generation
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box className='create_nft'>
                <Container maxWidth='xl'>
                    <Grid container spacing={2}>
                        <Grid item lg={3} sm={6} md={6} xs={12} margin='auto'>
                            <Box className='single'>
                                <Link to='/single-nft'>
                                    <img src={single} alt='single' />
                                    <Typography variant='h4'>
                                        Single NFT
                                    </Typography>
                                </Link>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
         </div>

    )
}

export default Create;